import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/flatpickr.min';
import {Polish} from "flatpickr/dist/l10n/pl.js"

const datepicker = (container = false) => {
    const datepicker = container ? $(container).find(".datepicker") : $(".datepicker");
    // const containerNode = document.querySelector('.dashboard__content');
    // if (!containerNode) return;
    let defaults = {
        "time_24hr": true,
        "locale": Polish,
        // "appendTo": containerNode,
        onChange: function (dObj, dStr, fp) {
            const input = $(fp.input);

            // ustawia dynamiczną wartość dla inputa "range"
            if (input.hasClass('datepicker-range-from')) {
                const rangeTo = input.closest('form').find('.datepicker-range-to').get(0);
                const fpRangeTo = rangeTo._flatpickr;

                const newDate = dObj.length ? dObj[0] : null;
                const selectedDate = fpRangeTo.selectedDates.length ? fpRangeTo.selectedDates[0] : null;
                if (newDate && selectedDate) {
                    const newDateTime = newDate.getTime();
                    const selectedDateTime = selectedDate.getTime();

                    if (newDateTime > selectedDateTime) {
                        fpRangeTo.setDate(dStr);
                    }
                }

                if (!selectedDate) {
                    fpRangeTo.setDate(dStr);
                }
            }

            if (input.hasClass('datepicker-range-to')) {
                const rangeFrom = input.closest('form').find('.datepicker-range-from').get(0);
                const fpRangeFrom = rangeFrom._flatpickr;

                const newDate = dObj.length ? dObj[0] : null;
                const selectedDate = fpRangeFrom.selectedDates.length ? fpRangeFrom.selectedDates[0] : null;

                if (newDate && selectedDate) {
                    const newDateTime = newDate.getTime();
                    const selectedDateTime = selectedDate.getTime();

                    if (newDateTime < selectedDateTime) {
                        fpRangeFrom.setDate(dStr);
                    }
                }

                if (!selectedDate) {
                    fpRangeFrom.setDate(dStr);
                }
            }
        }
    };
    datepicker.each((i, item) => {
        const $item = $(item);
        if ($item.siblings('[data-siblings-container]').length) {
            let config = {
                appendTo: $item.siblings('[data-siblings-container]').get(0),
            };
            $.extend(defaults, config);
        }
        $(item).flatpickr(defaults);
    });
};

export default datepicker;



// WEBPACK FOOTER //
// ./src/assets/js/common/datepicker.js